
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import NotificationTypeDropdown from "./NotificationTypeDropdown";
import AIAnalysisTools from "./AIAnalysisTools";
import { Notification } from "@/hooks/useNotificationDetail";
import StatusSelect from "./form/StatusSelect";

interface NotificationEditFormProps {
  notification: Notification;
  editedNotification: Notification | null;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  isAnalyzing: boolean;
  setIsAnalyzing: (isAnalyzing: boolean) => void;
  onAnalysisComplete: (data: { formattedText: string; voNumber: string | null }) => void;
}

const NotificationEditForm = ({
  notification,
  editedNotification,
  handleInputChange,
  isAnalyzing,
  setIsAnalyzing,
  onAnalysisComplete
}: NotificationEditFormProps) => {
  if (!editedNotification) return null;
  
  const handlePriorityChange = (checked: boolean) => {
    handleInputChange({
      target: { 
        name: 'priority', 
        value: checked ? 'hoog' : 'normaal'  // Always use "normaal" instead of null
      } as HTMLInputElement
    } as React.ChangeEvent<HTMLInputElement>);
  };

  const handleStatusChange = (value: string) => {
    handleInputChange({
      target: { 
        name: 'status', 
        value: value 
      } as HTMLSelectElement
    } as React.ChangeEvent<HTMLSelectElement>);
  };

  const handleTypeChange = (value: string) => {
    handleInputChange({
      target: { 
        name: 'type', 
        value: value 
      } as HTMLInputElement
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="type">Type</Label>
          <NotificationTypeDropdown
            type={editedNotification.type}
            onValueChange={handleTypeChange}
          />
        </div>

        <div>
          <Label htmlFor="vo_number">VO Nummer</Label>
          <Input
            id="vo_number"
            name="vo_number"
            placeholder="VO-2023-001"
            value={editedNotification.vo_number || ""}
            onChange={handleInputChange}
          />
        </div>
      </div>

      <div>
        <Label htmlFor="exact_order_number">Exact Ordernummer</Label>
        <Input
          id="exact_order_number"
          name="exact_order_number"
          placeholder="12345"
          value={editedNotification.exact_order_number || ""}
          onChange={handleInputChange}
        />
      </div>

      <StatusSelect
        status={editedNotification.status}
        onStatusChange={handleStatusChange}
        required={true}
      />


      <div className="flex items-center space-x-2">
        <Checkbox 
          id="priority" 
          checked={editedNotification.priority === 'hoog'}
          onCheckedChange={handlePriorityChange}
        />
        <Label htmlFor="priority" className="font-medium cursor-pointer">
          Hoge prioriteit
        </Label>
      </div>
    </div>
  );
};

export default NotificationEditForm;
